import { Space, Button, Select, Row, Col, Statistic, DatePicker, Flex, Typography, Tag, Divider } from 'antd';
import { formatCurrency } from 'utils/number';
import { formatOnlyDate } from 'utils/date';
import AddDebt from 'components/debt/AddDebt';
import AddPayment from 'components/debt/AddPayment';
import PaymentDetail from 'components/debt/PaymentDetail';
import dayjs from 'dayjs';

const { Text } = Typography;

const DebtMobile = ({
  lstDebtFilled,
  updateDebt,
  debtFilter,
  debt,
  customer,
  onChange,
  showUpdateDebt,
  closeUpdateDebt,
  printDebt,
  onMenuClick,
  setFilterType,
  setFilterStart,
}) => {
  return (
    <>
      <Space direction="vertical" size={12} style={{ width: '100%' }}>
        {/* Date filter */}
        <DatePicker
          style={{ width: '100%' }}
          showNow={false}
          value={debtFilter.start}
          onChange={setFilterStart}
          presets={[
            { label: 'Lần thanh toán gần đây', value: dayjs(customer.debt?.last_payment_date).startOf('day') },
            { label: 'Ngày sạch nợ', value: dayjs(customer.debt?.zero_debt_date).startOf('day') },
            { label: '1 tháng trước', value: dayjs().add(-1, 'month').startOf('day') },
            { label: '2 tháng trước', value: dayjs().add(-2, 'month').startOf('day') },
            { label: '3 tháng trước', value: dayjs().add(-3, 'month').startOf('day') },
          ]}
        />

        {/* Stats */}
        <Row gutter={[8, 8]}>
          <Col span={12}><Statistic title="Đầu kỳ" value={formatCurrency(debt.begin)} /></Col>
          <Col span={12}><Statistic title="Mua mới" value={formatCurrency(debt.debt)} /></Col>
          <Col span={12}><Statistic title="Thanh toán" value={formatCurrency(debt.payment)} /></Col>
          <Col span={12}><Statistic title="Còn nợ" value={formatCurrency(debt.remain)} /></Col>
        </Row>

        {/* Actions */}
        <Space direction="vertical" size={8} style={{ width: '100%' }}>
          <Select
            style={{ width: '100%' }}
            value={debtFilter.type}
            onChange={setFilterType}
            options={[
              { value: 'all', label: 'Tất cả' },
              { value: 'debt', label: 'Ghi nợ' },
              { value: 'payment', label: 'Thanh toán' },
            ]}
          />
          <Flex gap={8}>
            <div style={{ flex: 1 }}>
              <AddPayment onSaved={onChange} customer_id={customer.id} block />
            </div>
            <div style={{ flex: 1 }}>
              <AddDebt onSaved={onChange} customer_id={customer.id} block />
            </div>
          </Flex>
          <Button block onClick={printDebt}>
            Tải xuống PDF
          </Button>
        </Space>

        {/* Debt list */}
        <Space direction="vertical" size={0} style={{ width: '100%' }}>
          {(lstDebtFilled || []).map((record, index) => (
            <div key={record.id ?? index}>
              <Flex justify="space-between" align="center" style={{ padding: '10px 0' }}>
                <Space direction="vertical" size={2} style={{ flex: 1, minWidth: 0 }}>
                  <Flex align="center" gap={6}>
                    {record.type === 'payment' ? (
                      <Button
                        type="link"
                        size="small"
                        style={{ padding: 0, height: 'auto', fontSize: 12 }}
                        onClick={() => showUpdateDebt(record.id)}
                      >
                        {formatOnlyDate(record.date)}
                      </Button>
                    ) : (
                      <Text style={{ fontSize: 12 }} type="secondary">{formatOnlyDate(record.date)}</Text>
                    )}
                    <Tag
                      color={record.type === 'payment' ? 'success' : 'warning'}
                      style={{ fontSize: 11, lineHeight: '18px', padding: '0 4px' }}
                    >
                      {record.type === 'payment' ? 'Thanh toán' : 'Ghi nợ'}
                    </Tag>
                  </Flex>
                  {record.description ? (
                    <Text style={{ fontSize: 13 }} ellipsis={{ tooltip: record.description }}>
                      {record.description}
                    </Text>
                  ) : null}
                </Space>
                <Text strong style={{ fontSize: 14, flexShrink: 0, marginLeft: 12 }}>
                  {formatCurrency(record.amount)}
                </Text>
              </Flex>
              {index < (lstDebtFilled?.length ?? 0) - 1 && <Divider style={{ margin: 0 }} />}
            </div>
          ))}
          {(!lstDebtFilled || lstDebtFilled.length === 0) && (
            <Text type="secondary">Chưa có dữ liệu công nợ</Text>
          )}
        </Space>
      </Space>

      <PaymentDetail
        onSaved={onChange}
        open={updateDebt.isShow}
        id={updateDebt.id}
        onClose={closeUpdateDebt}
      />
    </>
  );
};

export default DebtMobile;
